import * as React from "react";
import { SVGProps } from "react";
export const ThumbUpFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14.0001 17.4999H5.66675V6.66658L11.5001 0.833252L12.5417 1.87492C12.639 1.97214 12.7188 2.10409 12.7813 2.27075C12.8438 2.43742 12.8751 2.59714 12.8751 2.74992V3.04159L11.9584 6.66658H16.5001C16.9445 6.66658 17.3334 6.83325 17.6667 7.16658C18.0001 7.49992 18.1667 7.88881 18.1667 8.33325V9.99992C18.1667 10.0971 18.1563 10.2013 18.1355 10.3124C18.1147 10.4235 18.0834 10.5277 18.0417 10.6249L15.5417 16.4999C15.4167 16.7777 15.2084 17.0138 14.9167 17.2083C14.6251 17.4027 14.3195 17.4999 14.0001 17.4999ZM4.00008 6.66658V17.4999H0.666748V6.66658H4.00008Z"
            fill="currentColor"
        />
    </svg>
);
ThumbUpFillIcon.displayName = "ThumbUpFillIcon";
